module.exports = __webpack_public_path__ + "img/edit.2cd95c49.png";